<template>
  <div style="padding: 35px 0px;">
    
      <p class="txtFed" @click="collapse2 = !collapse2">Vídeos Explicativos <img src="/sandboxfront/img/setaSBaixo.svg" alt="" ></p>
      <div :class="{abrir:true,collapsaee:collapse2}">
            <div class="ajuste" >
            <div class="blocoImagem" v-for="(n,i) in dados.videos" :key="i" @click="abrirLink(n.link)">
              <img :src="n.thumbnail" alt="" style="">
              <p style="padding:10px;font-weight:bold;color:#4A154B;    letter-spacing: -1px;">{{n.titulo}}</p>
              
               <div v-html="n.subtitulo" class="descricao">
          </div> 
            </div>
        </div>
      </div>
       <p class="txtFed" style="margin-top:40px;" @click="collapse = !collapse">Modelos de Documentos<img src="/sandboxfront/img/setaSBaixo.svg" alt="" /></p>
      <div :class="{abrir:true,collapsaee:collapse}">
          <Bloco :dados="dados.documentos" t="federal" />
      </div>
  </div>

</template>

<script>
import Bloco from '../components/Bloco.vue'
import calculo from '../services/calculo'
export default {
    components:{
        Bloco
    },
    data(){
        return{
            collapse:true,
            collapse2:true,
            dados:[]
        }
    },
    methods:{
         abrirLink(link){
            window.open(link,'_blank')
        }
    },
    async mounted(){
     
        let result = await calculo.AplicacaoFederal()
        if(result.status <=205){
            this.dados = result.data
        }
    }

}
</script>

<style>
.blocoImagem img{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 149px;    
    width: 270px;
}
.blocoImagem{
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    text-align: justify;    
    border: 1px solid #4A154B;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    border-radius: 10px;
    margin-top: 10px;    
    cursor: pointer;
    align-items: flex-start;
}
.collapsaee{
  display: inherit !important;
}
.abrir{
    display: none;  
 
}
.txtFed{
    color:#4A154B;
    font-weight: bold;
    cursor: pointer;    
    border-bottom: 1px solid #000000;
    padding-bottom: 7px;
    padding: 0px 30px;
    font-size: 1.1em;
}
@media screen and (max-width: 900px) {
.blocoImagem img{   
    width: 100%;
}
}
</style>